<template>
  <div>
    <v-card flat>
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> Print Receipt </strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-btn
        v-if="learner_receipt_data != null"
        class="ma-2 no-display"
        id="wv_btn"
        tile
        outlined
        color="warning"
        @click="print()"
      >
        <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
      </v-btn>
      <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
        <v-radio label="Both" value="both" color="#0f2027"></v-radio>
        <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
        <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
      </v-radio-group>
      <div id="document1">
      <v-row
        v-if="learner_receipt_data != null && radios != 'both'"
        style="margin-top: -20px"
      >
        <v-col
          cols="12"
          sm="6"
          md="6"
          class="m-0 p-0"
          v-if="radios == 'office'"
        >
          <v-card>
            <div class="outer-div">
              <span align="left">Office Copy</span>
              <div class="inner-div">
                <v-row>
                  <v-col cols="2">
                    <center>
                      <img class="trust_logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left:5px"
                      />
                    </center>
                  </v-col>
                  <v-col cols="8" style="padding-bottom: 0">
                    <h2>
                      <center>{{ org_basic_data.school_name }}</center>
                    </h2>
                    <span
                      ><center style="padding-left: 15px; padding-right: 15px;">{{ org_basic_data.address }}</center></span
                    >
                  </v-col>
                  <v-col cols="2 pb-0">
                    <center>
                      <img class="school-logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left: -10px;"
                      />
                    </center>
                  </v-col>
                </v-row>
                <center><b>FEE RECEIPT</b></center>
                <table id="table-id">
                  <tr>
                    <td>Receipt No</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_no }}</b>
                    </td>
                    <td>Date</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_date }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Student Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.name }}</b>
                    </td>
                    <td>Student-ID</td>
                    <td>
                      <b>: {{ learner_receipt_data.registration_number }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Mother Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.mother_full_name }}</b>
                    </td>
                    <td>Course</td>
                    <td><b>: </b></td>
                  </tr>
                  <tr>
                    <td>Division</td>
                    <td>
                      <b>: {{ learner_receipt_data.division }}</b>
                    </td>
                    <td>Class</td>
                    <td>
                      <b>: {{ learner_receipt_data.standard }}</b>
                    </td>
                  </tr>
                </table>
                <v-row dense style="margin: 0">
                  <v-col cols="12" sm="9" md="9" style="border: 1px solid black"
                    ><b> Description</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                    style="border: 1px solid black; text-align: right"
                    ><b> Amount ₹</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="9"
                    md="9"
                    class="line-height"
                    style="height: 245px; border-right: 1px solid black"
                  >
                    <v-row
                      dense
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                      class="component"
                      style="padding-left: 5px; font-size: 10px"
                    >
                      {{ lrd.component }}
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-row
                      dense
                      class="component"
                      style="justify-content: right; font-size: 10px; padding-right:5px;"
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                    >
                      {{ lrd.amount }}.00
                    </v-row>
                  </v-col>
                </v-row>
                <table class="total-table">
                  <tr>
                    <td class="total"
                      style="
                        text-align: right;
                        width: 80.8%;
                        padding-right: 50px;
                      "
                    >
                      <b>TOTAL :</b>
                    </td>
                    <td style="text-align: right; padding-right: 5px">
                      ₹ {{ learner_receipt_data.total_fees_amount }}.00
                    </td>
                  </tr>
                </table>
                <div
                  class="row pt-4 bottom-info"
                  style="padding-left: 5px; bottom: 0; line-height: 140%;"
                >
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <b>Mode Of Payment : </b
                    >{{ learner_receipt_data.payment_mode }}
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <center><b>Date : </b>{{ learner_receipt_data.transaction_date }}</center>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Amount in Words : </b
                    >{{ learner_receipt_data.amount_in_words }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Instrument No : </b>{{ learner_receipt_data.trnx_id }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Bank Name : </b>{{ learner_receipt_data.bank_name }}
                  </v-col>
                  <v-col cols="12" sm="8" md="8" class="mt-0 pt-0 pb-0">
                    <b>Remark : </b>{{ learner_receipt_data.remark }}
                  </v-col>
                  <v-col cols="12" sm="4" md="4" style="padding: 0; padding-bottom: 1px;">
                    <img  v-if="org_basic_data.sign != '--' && org_basic_data.sign != ''" class="sign-size-1" :src="org_basic_data.sign" width="80px" height="50px" style="margin-left: 35%; margin-bottom: -16px;"/> 
                    <div v-else style="height: 30px; width: 80px;"></div>
                    <center><b>Signature</b></center>
                  </v-col>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          class="m-0 p-0"
          v-if="radios == 'student'"
        >
          <v-card>
            <div class="outer-div">
              <span align="left">Student Copy</span>
              <div class="inner-div">
                <v-row>
                  <v-col cols="2">
                    <center>
                      <img class="trust_logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left:5px"
                      />
                    </center>
                  </v-col>
                  <v-col cols="8" style="padding-bottom: 0">
                    <h2>
                      <center>{{ org_basic_data.school_name }}</center>
                    </h2>
                    <span
                      ><center style="padding-left: 15px; padding-right: 15px;">{{ org_basic_data.address }}</center></span
                    >
                  </v-col>
                  <v-col cols="2">
                    <center>
                      <img class="school-logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left: -10px;"
                      />
                    </center>
                  </v-col>
                </v-row>
                <center><b>FEE RECEIPT</b></center>
                <table id="table-id">
                  <tr>
                    <td>Receipt No</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_no }}</b>
                    </td>
                    <td>Date</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_date }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Student Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.name }}</b>
                    </td>
                    <td>Student-ID</td>
                    <td>
                      <b>: {{ learner_receipt_data.registration_number }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Mother Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.mother_full_name }}</b>
                    </td>
                    <td>Course</td>
                    <td><b>: </b></td>
                  </tr>
                  <tr>
                    <td>Division</td>
                    <td>
                      <b>: {{ learner_receipt_data.division }}</b>
                    </td>
                    <td>Class</td>
                    <td>
                      <b>: {{ learner_receipt_data.standard }}</b>
                    </td>
                  </tr>
                </table>
                <v-row dense style="margin: 0">
                  <v-col cols="12" sm="9" md="9" style="border: 1px solid black"
                    ><b> Description</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                    style="border: 1px solid black; text-align: right"
                    ><b> Amount ₹</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="9"
                    md="9"
                    class="line-height"
                    style="height: 245px; border-right: 1px solid black"
                  >
                    <v-row
                      dense
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                      class="component"
                      style="padding-left: 5px; font-size: 10px"
                    >
                      {{ lrd.component }}
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-row
                      dense
                      class="component"
                      style="justify-content: right; font-size: 10px; padding-right: 5px;"
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                    >
                      {{ lrd.amount }}.00
                    </v-row>
                  </v-col>
                </v-row>
                <table class="total-table">
                  <tr>
                    <td class="total"
                      style="
                        text-align: right;
                        width: 80.8%;
                        padding-right: 50px;
                      "
                    >
                      <b>TOTAL :</b>
                    </td>
                    <td style="text-align: right; padding-right: 5px;">
                      ₹ {{ learner_receipt_data.total_fees_amount }}.00
                    </td>
                  </tr>
                </table>
                <div
                  class="row pt-4 bottom-info"
                  style="padding-left: 5px; bottom: 0; line-height: 140%;"
                >
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <b>Mode Of Payment : </b
                    >{{ learner_receipt_data.payment_mode }}
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <center><b>Date : </b>{{ learner_receipt_data.transaction_date }}</center>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Amount in Words : </b
                    >{{ learner_receipt_data.amount_in_words }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Instrument No : </b>{{ learner_receipt_data.trnx_id }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Bank Name : </b>{{ learner_receipt_data.bank_name }}
                  </v-col>
                  <v-col cols="12" sm="8" md="8" class="mt-0 pt-0 pb-0">
                    <b>Remark : </b>{{ learner_receipt_data.remark }}
                  </v-col>
                  <v-col cols="12" sm="4" md="4" style="padding: 0; padding-bottom: 1px;">
                    <img  v-if="org_basic_data.sign != '--' && org_basic_data.sign != ''" class="sign-size-1" :src="org_basic_data.sign" width="80px" height="50px" style="margin-left: 35%; margin-bottom: -16px;"/> 
                    <div v-else style="height: 30px; width: 80px;"></div>
                    <center><b>Signature</b></center>
                  </v-col>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-if="learner_receipt_data != null && radios == 'both'"
        style="margin-top: -20px"
      >
        <v-col cols="12" sm="6" md="6" class="m-0 p-0">
          <v-card>
            <div class="outer-div">
              <span align="left">Office Copy</span>
              <div class="inner-div">
                <v-row>
                  <v-col cols="2">
                    <center>
                      <img class="trust_logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left:5px"
                      />
                    </center>
                  </v-col>
                  <v-col cols="8" style="padding-bottom: 0">
                    <h2>
                      <center>{{ org_basic_data.school_name }}</center>
                    </h2>
                    <span
                      ><center style="padding-left: 15px; padding-right: 15px;">{{ org_basic_data.address }}</center></span
                    >
                  </v-col>
                  <v-col cols="2">
                    <center>
                      <img class="school-logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left: -10px;"
                      />
                    </center>
                  </v-col>
                </v-row>
                <center><b>FEE RECEIPT</b></center>
                <table id="table-id">
                  <tr>
                    <td>Receipt No</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_no }}</b>
                    </td>
                    <td>Date</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_date }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Student Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.name }}</b>
                    </td>
                    <td>Student-ID</td>
                    <td>
                      <b>: {{ learner_receipt_data.registration_number }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Mother Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.mother_full_name }}</b>
                    </td>
                    <td>Course</td>
                    <td><b>: </b></td>
                  </tr>
                  <tr>
                    <td>Division</td>
                    <td>
                      <b>: {{ learner_receipt_data.division }}</b>
                    </td>
                    <td>Class</td>
                    <td>
                      <b>: {{ learner_receipt_data.standard }}</b>
                    </td>
                  </tr>
                </table>
                <v-row dense style="margin: 0">
                  <v-col cols="12" sm="9" md="9" style="border: 1px solid black"
                    ><b> Description</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                    style="border: 1px solid black; text-align: right"
                    ><b> Amount ₹</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="9"
                    md="9"
                    class="line-height"
                    style="height: 245px; border-right: 1px solid black"
                  >
                    <v-row
                      dense
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                      class="component"
                      style="padding-left: 5px; font-size: 10px"
                    >
                      {{ lrd.component }}
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-row
                      dense
                      class="component"
                      style="justify-content: right; font-size: 10px; padding-right: 5px;"
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                    >
                      {{ lrd.amount }}.00
                    </v-row>
                  </v-col>
                </v-row>
                <table class="total-table">
                  <tr>
                    <td class="total"
                      style="
                        text-align: right;
                        width: 80.8%;
                        padding-right: 50px;
                      "
                    >
                      <b>TOTAL :</b>
                    </td>
                    <td style="text-align: right; padding-right: 5px">
                      ₹ {{ learner_receipt_data.total_fees_amount }}.00
                    </td>
                  </tr>
                </table>

                <div
                  class="row pt-4 bottom-info"
                  style="padding-left: 5px; bottom: 0; line-height: 140%;"
                >
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <b>Mode Of Payment : </b
                    >{{ learner_receipt_data.payment_mode }}
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <center><b>Date : </b>{{ learner_receipt_data.transaction_date }}</center>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Amount in Words : </b
                    >{{ learner_receipt_data.amount_in_words }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Instrument No : </b>{{ learner_receipt_data.trnx_id }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Bank Name : </b>{{ learner_receipt_data.bank_name }}
                  </v-col>
                  <v-col cols="12" sm="8" md="8" class="mt-0 pt-0 pb-0">
                    <b>Remark : </b>{{ learner_receipt_data.remark }}
                  </v-col>
                  <v-col cols="12" sm="4" md="4" style="padding: 0; padding-bottom: 1px;">
                    <img  v-if="org_basic_data.sign != '--' && org_basic_data.sign != ''" class="sign-size-1" :src="org_basic_data.sign" width="80px" height="50px" style="margin-left: 35%; margin-bottom: -16px;"/> 
                    <div v-else style="height: 30px; width: 80px;"></div>
                    <center><b>Signature</b></center>
                  </v-col>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
        <div class="partition-line"></div>
        <v-col cols="12" sm="6" md="6" class="m-0 p-0">
          <v-card>
            <div class="outer-div">
              <span align="left">Student Copy</span>
              <div class="inner-div">
                <v-row>
                  <v-col cols="2">
                    <center>
                      <img class="trust_logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left:5px"
                      />
                    </center>
                  </v-col>
                  <v-col cols="8" style="padding-bottom: 0">
                    <h2>
                      <center>{{ org_basic_data.school_name }}</center>
                    </h2>
                    <span
                      ><center style="padding-left: 15px; padding-right: 15px;">{{ org_basic_data.address }}</center></span
                    >
                  </v-col>
                  <v-col cols="2">
                    <center>
                      <img class="school-logo"
                        :src="org_basic_data.trust_logo"
                        width="110px"
                        height="90px"
                        alt="logo"
                        style="margin-left: -10px;"
                      />
                    </center>
                  </v-col>
                </v-row>
                <center><b>FEE RECEIPT</b></center>
                <table id="table-id">
                  <tr>
                    <td>Receipt No</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_no }}</b>
                    </td>
                    <td>Date</td>
                    <td>
                      <b>: {{ learner_receipt_data.receipt_date }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Student Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.name }}</b>
                    </td>
                    <td>Student-ID</td>
                    <td>
                      <b>: {{ learner_receipt_data.registration_number }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Mother Name</td>
                    <td>
                      <b>: {{ learner_receipt_data.mother_full_name }}</b>
                    </td>
                    <td>Course</td>
                    <td><b>: </b></td>
                  </tr>
                  <tr>
                    <td>Division</td>
                    <td>
                      <b>: {{ learner_receipt_data.division }}</b>
                    </td>
                    <td>Class</td>
                    <td>
                      <b>: {{ learner_receipt_data.standard }}</b>
                    </td>
                  </tr>
                </table>
                <v-row dense style="margin: 0">
                  <v-col cols="12" sm="9" md="9" style="border: 1px solid black"
                    ><b> Description</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                    style="border: 1px solid black; text-align: right"
                    ><b> Amount ₹</b></v-col
                  >
                  <v-col
                    cols="12"
                    sm="9"
                    md="9"
                    class="line-height"
                    style="height: 245px; border-right: 1px solid black"
                  >
                    <v-row
                      dense
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                      class="component"
                      style="padding-left: 5px; font-size: 10px"
                    >
                      {{ lrd.component }}
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-row
                      dense
                      class="component"
                      style="justify-content: right; font-size: 10px; padding-right: 5px;"
                      v-for="lrd in learner_receipt_data.student_receipt_details"
                      :key="lrd.id"
                    >
                      {{ lrd.amount }}.00
                    </v-row>
                  </v-col>
                </v-row>
                <table class="total-table">
                  <tr>
                    <td class="total"
                      style="
                        text-align: right;
                        width: 80.8%;
                        padding-right: 50px;
                      "
                    >
                      <b>TOTAL :</b>
                    </td>
                    <td style="text-align: right; padding-right: 5px">
                      ₹ {{ learner_receipt_data.total_fees_amount }}.00
                    </td>
                  </tr>
                </table>
                <div
                  class="row pt-4 bottom-info"
                  style="padding-left: 5px; bottom: 0;line-height: 140%;"
                >
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <b>Mode Of Payment : </b
                    >{{ learner_receipt_data.payment_mode }}
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="mt-0 pt-0 pb-0">
                    <center><b>Date : </b>{{ learner_receipt_data.transaction_date }}</center>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Amount in Words : </b
                    >{{ learner_receipt_data.amount_in_words }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Instrument No : </b>{{ learner_receipt_data.trnx_id }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-0 pt-0 pb-0">
                    <b>Bank Name : </b>{{ learner_receipt_data.bank_name }}
                  </v-col>
                  <v-col cols="12" sm="8" md="8" class="mt-0 pt-0 pb-0">
                    <b>Remark : </b>{{ learner_receipt_data.remark }}
                  </v-col>
                  <v-col cols="12" sm="4" md="4" style="padding: 0; padding-bottom: 1px;">
                    <img  v-if="org_basic_data.sign != '--' && org_basic_data.sign != ''" class="sign-size-1" :src="org_basic_data.sign" width="80px" height="50px" style="margin-left: 35%; margin-bottom: -16px;"/> 
                    <div v-else style="height: 30px; width: 80px;"></div>
                    <center><b>Signature</b></center>
                  </v-col>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      overlay: false,
      learner_receipt_data: null,
      radios: null,
      receipt_no: null,
      registration_no: null,
      ay: null,
      org_basic_data: [],
      org_id: null,
    };
  },
  watch: {
    receipt_no() {
      this.getData();
    },

    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  created() {
    this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
    this.ay = JSON.parse(this.$session.get("ay"));
    this.registration_no = JSON.parse(this.$session.get("registration_no"));
  },
  mounted() {
    this.getData();
    this.org_id = localStorage.getItem("EPS-org-id")
  },
  methods: {
    print() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
    convert(number) {
      var converter = require("number-to-words");
      const string = converter.toWords(number);
      const string1 = string.charAt(0).toUpperCase() + string.slice(1);
      return string1;
    },
    getData() {
      this.overlay = true;
      this.learner_receipt_data = null;
      const formData = {
        receipt_no: this.receipt_no,
        registration_no: this.registration_no,
        ay: this.ay,
      };
      axios
        .post("/AccountingAndFeesReports/getFeeReceipts", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_receipt_data = res.data.student_receipt_details;
            this.org_basic_data = res.data.org_basic_data;
            this.overlay = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.overlay = false;
            return;
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.overlay = false;
        })
        .finally(() => {
          //close loader
          this.overlay = false;
        });
    },
  },
};
</script>
<style scoped>
@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
.inner-div {
  border: 1px solid black;
  height: 92vh;
}
.outer-div {
  /* margin-right: -5px; */
  /* border-right: dashed 1px black; */
}
#table-id {
  width: 100%;
  border-collapse: collapse;
  margin-left: 15px;
  margin-right: 15px;
}
#table-id td {
  border: none;
  text-align: left;
  width: 25%;
}
#table-id td:first-child, td:nth-child(3) {
  border: none;
  text-align: left;
  width: 15% !important;
}
#table-id tr {
  border: none;
}
#middle-table {
  border-collapse: collapse;
  width: 100%;
  /* height: 38vh; */
}
#middle-table th {
  border: 1px solid black;
  padding-left: 10px;
}
#middle-table tbody {
  /* display: block; */
  /* width: 100% !important; */
}
#middle-table td {
  padding-left: 10px;
  border-right: 1px solid black;
}

#th-1 {
  text-align: left;
  width: 80%;
}
.total-table {
  border-collapse: collapse;
  border: 1px solid black;
  width: 100%;
  /* border-top: none; */
  position: absolute;
  bottom: 150px;
}
.partition-line {
  border-right: 1px dashed black;
  margin-right: -1px;
}

@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  @page {
    margin-top: none;
    padding-top: none;
    margin-left: 120px !important;
    size: 25in 15in;
  }
  .bottom-info{
    line-height: 50% !important;
    padding-top: 20px;
  }
  .outer-div {
    font-size: x-large !important;
    font-weight: 600 !important;
    /* margin-top: -80px; */
  }
  .line-height {
    height: 595px !important;
  }
  .component {
    font-size: 22.5px !important;
  }
  .total{
    padding-right: 90px !important;
  }
  .sign-size{
    width: 100px !important;
    height: 70px !important;
    margin-bottom: -30px !important;
  }
  .sign-size-1{
    width: 100px !important;
    height: 60px !important;
    margin-bottom: -6px !important;
    margin-top: -8px !important;
    padding-left: 15px !important;
  }
  .trust_logo{
    width: 210px !important;
    height: 180px !important;
  }
  .school-logo{
    width: 210px !important;
    height: 180px !important;
    margin-left: -50px !important;
  }
  table,
  td,
  tr,
  th {
    margin-top: none;
    padding: 0.3rem !important;
    font-size: x-large !important;
  }
  .total-table {
    border-collapse: collapse;
    border: 1px solid black;
    width: 100%;
    /* border-top: none; */
    position: absolute;
    bottom: 220px;
  }
}
.table-container {
  overflow-x: hidden;
  overflow: hidden;
}
.text {
  color: red !important;
  font-size: bold !important;
}
</style>
